"use client"

import { useState } from "react"
import { Button } from "../button"
import type { LucideIcon } from "lucide-react"

interface ButtonOption {
  id: string
  icon: LucideIcon
  label: string
}

interface SettingsButtonGroupProps {
  options: ButtonOption[]
  defaultSelected?: string
  onChange?: (selected: string) => void
}

export function SettingsButtonGroup({ options, defaultSelected, onChange }: SettingsButtonGroupProps) {
  const [selected, setSelected] = useState(defaultSelected || options[0]?.id)

  const handleSelect = (id: string) => {
    setSelected(id)
    onChange?.(id)
  }

  return (
    <div className="flex gap-2">
      {options.map((option) => {
        const Icon = option.icon
        return (
          <Button
            key={option.id}
            onClick={() => handleSelect(option.id)}
            className={`p-2 rounded-lg transition-colors ${
              selected === option.id ? "bg-indigo-600 text-white" : "bg-indigo-100 text-indigo-600 hover:bg-indigo-200"
            }`}
            title={option.label}
          >
            <Icon className="w-5 h-5" />
          </Button>
        )
      })}
    </div>
  )
}
